{
  "title": "Drift Queue",
  "tabs": {
    "needsAction": "Needs Action",
    "singleBreach": "Single Drift",
    "compoundBreach": "Compound Drift"
  },
  "table": {
    "portfolio": "Portfolio",
    "household": "Household",
    "accountType": "Account Type",
    "reason": "Reason",
    "custodian": "Custodian",
    "value": "Value",
    "cashAndPosition": "Cash / Position",
    "cashShort": "Cash",
    "positionShort": "Pos.",
    "positionUnavailable": "Position drift unavailable",
    "staleTooltip": "Stale data — as of {{date}}"
  },
  "empty": {
    "title": "No accounts require action today.",
    "filterNoResults": "No accounts match this filter."
  },
  "footer": {
    "rowCount": "Showing {{shown}} of {{total}} accounts needing action"
  },
  "legend": {
    "title": "Legend",
    "singleBreach": "Single Drift",
    "compoundBreach": "Compound Drift",
    "stale": "Stale Data",
    "international": "International Holdings"
  },
  "lastRefresh": {
    "label": "As of {{value}}"
  },
  "header": {
    "queueAlertLabel": "{{count}} in queue",
    "queueAlertA11yLabel": "{{count}} accounts in the action queue",
    "viewAll": "View All"
  },
  "breaches": {
    "liquidation": "Liquidation",
    "transfer": "Transfer",
    "drift": "Drift",
    "unverified_one": "{{count}} Unverified",
    "unverified_other": "{{count}} Unverified",
    "pending_one": "{{count}} Pending",
    "pending_other": "{{count}} Pending"
  }
}
